export default __webpack_public_path__ + "static/media/de.6435bf24.svg";